import { render } from "./IntroAnimation_2.vue?vue&type=template&id=6394417b&scoped=true"
const script = {}

import "./IntroAnimation_2.vue?vue&type=style&index=0&id=6394417b&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\mm\\Documents\\__Kundenprojekte\\ÜIM-HAB\\Entwicklung\\Frontend\\uebersetzen\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6394417b"]])

export default __exports__